import { render, staticRenderFns } from "./maphistory.vue?vue&type=template&id=272f475c&scoped=true&"
import script from "./maphistory.vue?vue&type=script&lang=js&"
export * from "./maphistory.vue?vue&type=script&lang=js&"
import style0 from "./maphistory.vue?vue&type=style&index=0&id=272f475c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272f475c",
  null
  
)

export default component.exports